import Echo from 'laravel-echo'
import Pusher from 'pusher-js'
import Cookies from 'js-cookie'

window.Pusher = Pusher

try {
    var echo = new Echo({
        broadcaster: 'pusher',
        key: 'lipindan-key-2026',
        cluster: 'mt1',
        wsHost: 'api.cainiaolipin.cn',
        wsPort: 80,
        wssPort: 443,
        forceTLS: false,
        disableStats: true, // 用于统计上报
        enabledTransports: ['ws'], // 只使用 WebSocket
        auth: {
                headers: {
                    Authorization: 'Bearer ' + Cookies.get('view_userToken')
                }
            },
        authEndpoint: window.location.protocol + '//api.cainiaolipin.cn/api/broadcasting/auth',
        // 保持连接活跃
        activityTimeout: 120000, // 120秒没活动才发ping
        pongTimeout: 30000 // 等pong的超时时间
    })
    console.log('Echo 初始化成功：', echo);
}catch (error) {
    console.error('Echo 初始化失败：', error);
}

export default echo;



// WEBPACK FOOTER //
// ./src/utils/echo.js